export default __webpack_public_path__ + "static/media/no-data.d9de2bc4.svg";